import { css } from '@/styled-system/css';

export const notificationCircleStyles = css.raw({
  position: 'absolute',
  width: '200',
  height: '200',
  top: '-1px',
  right: '-2px',
  borderRadius: 'ellipse',
  background: 'text.feedback.warning.hero',
  color: 'text.onImpact.neutral',
});
